import {Button, Divider, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {StyledCard, TagChip} from 'presentation/components';
import {translations as newTranslations, translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';

import {BillStatusEnum, MyPaymentsEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {useSelectedBilletStore} from 'presentation/pages/private/my-payments-flow/store/selectedBilletStore';
import {PaidBilletCardProps} from './types';

const {dueDate, paidIn} = translations['pt-br'].privateFlow.myFinancial;
const {showDetails, currencyUnit} = newTranslations['pt-br'].commons;

export function PaidBilletCard({
	billet: {dtPagamento, dtVencimento, mes, vlObrigacao, vlPagamento},
	year,
}: PaidBilletCardProps) {
	const displayValue =
		vlPagamento != null
			? vlPagamento.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				})
			: (vlObrigacao ?? '0,00');
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const setSelectedCurrentBillet = useSelectedBilletStore(state => state.setSelectedBillet);
	const {colors, palette} = useTheme();

	const formattedTargetDate = `${mes}/${year}`;

	const handleGoToDetails = () => {
		setSelectedCurrentBillet({
			dtPrevista: dtVencimento,
			cdObrigacao: 0,
			status: BillStatusEnum.PAID,
			flTipoPdf: false,
			flMigracao: false,
			cdObrigacaoOrigem: 0,
			linhaDigitavel: {
				vlObrigacao,
				dtVencimento,
				dtPagamento,
			},
			cdEspecieTitulo: 0,
		});
		navigate(MyPaymentsEnum.BILLET_DETAILS, {state: pathname});
	};

	return (
		<StyledCard.Container $borderTop $borderColor={colors.light.success.main} elevation={0}>
			<Stack gap={'16px'}>
				<Stack justifyContent="space-between" alignItems="center" direction="row">
					<Typography color={palette.text.primary} variant="h6">
						{formatText(formattedTargetDate)}
					</Typography>

					<TagChip label={BillStatusEnum.PAID} color={'success'} />
				</Stack>
				<Divider />
				<Stack gap={'8px'}>
					<Typography variant="body2" color={palette.text.secondary}>
						{dueDate}{' '}
						<Typography variant="body2" fontWeight={700} component="span">
							{dtVencimento}
						</Typography>
					</Typography>
					<Typography variant="body2" color={palette.text.secondary}>
						{paidIn}{' '}
						<Typography variant="body2" fontWeight={700} component="span">
							{dtPagamento}
						</Typography>
					</Typography>
					<Stack
						alignItems="center"
						color={colors.light.text.primary}
						direction="row"
						gap={0.5}>
						<Typography>{currencyUnit}</Typography>
						<Typography variant="h5" fontWeight={700}>
							{displayValue}
						</Typography>
					</Stack>
				</Stack>
			</Stack>
			<Stack alignItems={'end'}>
				<Button
					variant="text"
					endIcon={<Icon name="arrow-right" />}
					onClick={handleGoToDetails}>
					{showDetails}
				</Button>
			</Stack>
		</StyledCard.Container>
	);
}
